import React from "react";
import Main from "./Main";
import Layout from "./Layout";

const Home = () => {
  return (
    <Layout>
      <Main />
    </Layout>
  );
};

export default Home;
